// Represents list of dataSources for editable fields in Grids that uses dropdown
const Datasources = {
  routeName: {
    storeName: "IBPlanningStore",
    storeVariable: "routeNameList",
  },
  routeAssigned: {
    storeName: "IBPlanningStore",
    storeVariable: "deliveryRouteNameList",
  },
  liftgate: {
    storeName: "CommonStore",
    storeVariable: "liftgateList",
  },
  anchorPointName: {
    storeName: "CommonStore",
    storeVariable: "anchorPointList",
  },
  status: {
    storeName: "CommonStore",
    storeVariable: "lockOptionsList",
  },
  trailerName: {
    storeName: "CommonStore",
    storeVariable: "trailersList",
  },
  isTrapRoute: {
    storeName: "CommonStore",
    storeVariable: "routeTypeList",
  },
  tractorNumber: {
    storeName: "DispatchStore",
    storeVariable: "tractorList",
  },
  dispatchRouteName: {
    storeName: "DispatchStore",
    storeVariable: "dispatchRouteList",
  },
  dispatchDrivers: {
    storeName: "DispatchStore",
    storeVariable: "dispatchDrivers",
  },
  trailerLength: {
    storeName: "CommonStore",
    storeVariable: "trailerLengthList",
  },
  recommendedDriverName: {
    storeName: "DispatchStore",
    storeVariable: "activeDriversList",
  },
  packageCode: {
    storeName: "DispatchStore",
    storeVariable: "packageCodes",
  },
  packageCodeWithSuffix: {
    storeName: "DispatchStore",
    storeVariable: "packageCodesWithSuffix",
  },
  serviceLevel: {
    storeName: "DispatchStore",
    storeVariable: "serviceLevelShipmentOptions",
  },
  dispatchedDriversList: {
    storeName: "DispatchStore",
    storeVariable: "dispatchedDriversListForOptimization",
  },
  maxEquipSizes: {
    storeName: "CustomerStore",
    storeVariable: "maxEquipSizes",
  },
  overrideRoutes: {
    storeName: "CustomerStore",
    storeVariable: "overrideRoutes",
  },
  isFlexiApt: {
    storeName: "CommonStore",
    storeVariable: "flexiAptList"
  },
  routeType: {
    storeName: "IBPlanningStore",
    storeVariable: "routeTypeList",
  },
};
export default Datasources;